import { getDocumentChallengeState } from './challengeState';
import logger from '@spa/lib/logger';

export const CHALLENGE_SCRIPT_SRC = '/_fs-ch-1T1wmsGaOgGaSxcX/challenge.js';

export const loadChallengeScript = (ownerDocument: Document = document): void => {
  const state = getDocumentChallengeState(ownerDocument);
  if (state.beginDownload()) {
    const script = ownerDocument.createElement('script');
    script.src = CHALLENGE_SCRIPT_SRC;
    script.async = true;
    const cleanListeners = (): void => {
      script.removeEventListener('load', onLoad);
      script.removeEventListener('error', onError);
    };
    const onLoad = (): void => {
      state.acceptScriptLoad();
      cleanListeners();
    };
    const onError = (): void => {
      logger.warn({ src: CHALLENGE_SCRIPT_SRC }, 'Fastly challenge script failed to load');
      state.failIntegration('script-error');
      cleanListeners();
    };
    script.addEventListener('load', onLoad);
    script.addEventListener('error', onError);
    try {
      ownerDocument.head.appendChild(script);
    } catch {
      onError();
    }
  }
};
